module.exports = __webpack_public_path__ + "static/Adieu-Black-ec566d8350d690dcdfa2934afa9d009f.otf";